import React from 'react';
import { View } from 'react-native';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import NotificationBubble from './NotificationBubble';
import {
  Touchable,
  BodyText,
} from '../../../ui';
import { CloseIcon } from '../../../ui/Icons';

const CloseableNotificationBubble = ({
  text,
  textTouchableProps,
  closeIconTouchableProps,
  testID,
}: {
  text: string,
  textTouchableProps?: React.ComponentProps<typeof Touchable>,
  closeIconTouchableProps?: React.ComponentProps<typeof Touchable>,
  testID: string,
}) => (
  <NotificationBubble testID={testID}>
    <Touchable {...textTouchableProps}>
      <View>
        <Inline flexWrap="wrap" flexShrink={1}>
          <BodyText appearance="small">{text}</BodyText>
        </Inline>
      </View>
    </Touchable>
    <Touchable {...closeIconTouchableProps}>
      <View><CloseIcon width={16} height={16} color={colors.blackInBlack} /></View>
    </Touchable>
  </NotificationBubble>
);

export default CloseableNotificationBubble;
